const counsellingPath = 'counsellingPatients.';

const counsellingTrans = {
    SEEING_THE_WHOLE_PATIENT: counsellingPath + 'wholePatient',
    SEEING_THE_WHOLE_PATIENT_DESCRIPTION: counsellingPath + 'wholePatientDescription',

    EDUCATE_TO_EMPOWER: counsellingPath + 'educateToEmpower',
    EDUCATE_TO_EMPOWER_DESCRIPTION: counsellingPath + 'educateToEmpowerDescription',
    EDUCATE_TO_EMPOWER_SUB_TITLE: counsellingPath + 'educateToEmpowerFooter',
    EDUCATE_TO_EMPOWER_NOTES: counsellingPath + 'educateToEmpowerNote'
}

export default counsellingTrans